import script from "./VensoOrderItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoOrderItem.vue?vue&type=script&setup=true&lang=ts"

import "./VensoOrderItem.vue?vue&type=style&index=0&id=7fd59d90&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fd59d90"]])

export default __exports__